import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import _ from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Avatar from '@/src/components/common/Avatar/Avatar';
import { RootState } from '@/src/reducers/types';
import { cn } from '@/src/util/ui';

const AccessList = ({ member, onSelect, isActive = false }) => {
  const files = useSelector((state: RootState) => state.files);
  const [anchorEl, setAnchorEl] = useState(null);

  const actions = {
    editor: { id: 'editor', label: 'Editor', class: '' },
    remove: { id: 'remove', label: 'Remove Access', class: 'deleteWorkstream' },
  };

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectAction = (actionId) => {
    onSelect(member, actionId);
    handleClose();
  };

  return (
    <div className={`memberItem ${actions[member.access]?.id === 'remove' ? 'removed' : ''} `}>
      <div className="memberDetails">
        <div className="memberAvatar">
          <Avatar name={`${member['first-name']} ${member['last-name']}`} />
        </div>
        <div className="memberContent">
          <p>{`${member['first-name']} ${member['last-name']}`}</p>
        </div>
      </div>
      <div className="memberActions">
        <div className="memberRole">
          <span>{member.role ? member.role : member.title}</span>
        </div>
        <a
          onClick={member.editable ? handleClick : null}
          className={cn(
            'btn btnAssign',
            actions[member.access]?.id === 'remove' && 'btnRemove',
            open || (isActive && 'active'),
            !member.editable && 'disabled'
          )}
          aria-disabled={!member.editable}
        >
          <span>
            {actions[member.access]?.id === 'remove' ? 'Removed' : actions[member.access]?.label}
          </span>
          <i className="material-icons">arrow_drop_down</i>
        </a>
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
          style={{ zIndex: 100 }}
          className="accessListActions"
        >
          <ClickAwayListener onClickAway={handleClose}>
            <div className="actionsContainer">
              {Object.keys(actions).map((key) => (
                <div key={key} className={`actionItem ${actions[key].class}`}>
                  <a onClick={() => handleSelectAction(actions[key].id)}>
                    <span>{actions[key].label}</span>
                  </a>
                </div>
              ))}
            </div>
          </ClickAwayListener>
        </Popper>
      </div>
    </div>
  );
};

export default AccessList;
